<template>
  <div class="case-analysis-version-dailog dialog col-block width-full">
    <div class="case-analysis-version-title-container row-block">
      <div class="case-analysis-version-title">{{ $t('DIALOG.caseAnalysisVersion.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="case-analysis-version-main-container col-block width-full" :style="{ flex: 1 }">
      <div class="case-analysis-version-main-block col-block width-full" v-for="(option, oindex) in mainOptions" :key="oindex" :style="{ flex: 1 }">
        <div class="case-analysis-version-main-title-container row-block">
          <div class="case-analysis-version-main-title" v-html="option.title"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="case-analysis-version-main-content-container col-block width-full" :style="{ flex: 1 }">
          <caseDetailAnalysisVersionTable
            :defaultDatas="option.tableDatas"
          ></caseDetailAnalysisVersionTable>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import caseDetailAnalysisVersionTable from '../caseDetail/analysisVersionTable.vue'

export default {
  components: {
    caseDetailAnalysisVersionTable
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // static
    mainOptions () {
      return [
        {
          title: this.$t('DIALOG.caseAnalysisVersion.mainData.title.___pipeline'),
          tableDatas: this.tableDatas['pipeline']
        },
        {
          title: this.$t('DIALOG.caseAnalysisVersion.mainData.title.___analysis'),
          tableDatas: this.tableDatas['analysis']
        }
      ]
    },
    tableDatas () {
      return {
        'pipeline': [
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Hardware_Accelerated_Pipeline'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___DRAGEN'),
            version: this.analysisVersions['DRAGEN'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___GPU_Accelerated_Pipeline_Wrapper'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Parabrick_pbrun'),
            version: this.analysisVersions['pbrun'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Read_Aligner'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Parabrick_BWA_mem'),
            version: this.analysisVersions['BWA mem'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Variant_Caller'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Parabrick_deepvariant'),
            version: this.analysisVersions['DeepVariant'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Structural_Variant_Caller'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___Manta'),
            version: this.analysisVersions['Manta'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___CNV_Caller_Exome_Based'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___ExomeDepth'),
            version: this.analysisVersions['ExomeDepth'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___CNV_Caller_Control_Dataset'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___ExomeDepth_Baseline'),
            version: this.analysisVersions['ExomeDepth Baseline'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___Repeat_Expansion_Caller'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___ExpansionHunter'),
            version: this.analysisVersions['ExpansionHunter'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.category.___HLA_Genotyper'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.pipeline.name.___HISAT_genotype'),
            version: this.analysisVersions['HISAT2'] || '- -'
          }
        ],
        'analysis': [
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___Jannovar'),
            version: this.analysisVersions['jannovar'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___VEP'),
            version: this.analysisVersions['VEP'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___AnnotSV'),
            version: this.analysisVersions['AnnotSV'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Annotation_Tools_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___Jannovar_DB_Version'),
            version: this.analysisVersions['jannovar_gff'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Canonical_Transcript_Reference'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___MANE'),
            version: this.analysisVersions['MANE'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Protein_Function_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___UniProt'),
            version: this.analysisVersions['UniProt'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Structural_Variant_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbVar'),
            version: this.analysisVersions['dbVar'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Structural_Variant_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___Decipher'),
            version: this.analysisVersions['Decipher'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___GnomAD'),
            version: this.analysisVersions['GnomAD'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Clinical_Variant_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___ClinVar'),
            version: this.analysisVersions['ClinVar'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Clinical_Variant_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___HGMD'),
            version: this.analysisVersions['HGMD'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbNSFP'),
            version: this.analysisVersions['dbNSFP'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbscSNV'),
            version: this.analysisVersions['dbscSNV'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___SpliceAI'),
            version: this.analysisVersions['SpliceAI'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___In_Silico_Prediction_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___AlphaMissense'),
            version: this.analysisVersions['AlphaMissense'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Variant_Identifier_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___dbSNP'),
            version: this.analysisVersions['dbSNP'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___ESP6500'),
            version: this.analysisVersions['ESP6500'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___ExAC'),
            version: this.analysisVersions['ExAC'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___GenomeAsia_100K'),
            version: this.analysisVersions['GenomeAsia 100K'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Exomes'),
            version: this.analysisVersions['gnomAD Exomes'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___gnomAD_Genomes'),
            version: this.analysisVersions['gnomAD Genomes'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___1000_Genomes'),
            version: this.analysisVersions['1000 Genomes'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___TaiwanBioBank'),
            version: this.analysisVersions['TaiwanBioBank'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___tommo_60kjpn'),
            version: this.analysisVersions['tommo_60kjpn'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Population_Frequency_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___TOPMed'),
            version: this.analysisVersions['TOPMed'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Disease_Gene_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___OMIM'),
            version: this.analysisVersions['OMIM'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Disease_Gene_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___Orphanet'),
            version: this.analysisVersions['Orphanet'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Mitochondrial_Variant_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___MITOMAP'),
            version: this.analysisVersions['MITOMAP'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Phenotype_Ontology_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___HPO'),
            version: this.analysisVersions['HPO'] || '- -'
          },
          {
            category: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.category.___Phenotype_Ontology_Database'),
            name: this.$t('DIALOG.caseAnalysisVersion.tableData.analysis.name.___HPO'),
            version: this.analysisVersions['HPO'] || '- -'
          }
        ]
      }
    },
    // param
    analysisVersions () {
      return this.param.analysisVersions
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseAnalysisVersion.vue